// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__Za49d","noInteraction":"EventWrapper_noInteraction__3XHAt","pointerPassthrough":"EventWrapper_pointerPassthrough__32ZBp"};